import { render, staticRenderFns } from "./TabPanels.vue?vue&type=template&id=0cfb2758&scoped=true&"
import script from "./TabPanels.vue?vue&type=script&lang=js&"
export * from "./TabPanels.vue?vue&type=script&lang=js&"
import style0 from "./TabPanels.vue?vue&type=style&index=0&id=0cfb2758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfb2758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cfb2758')) {
      api.createRecord('0cfb2758', component.options)
    } else {
      api.reload('0cfb2758', component.options)
    }
    module.hot.accept("./TabPanels.vue?vue&type=template&id=0cfb2758&scoped=true&", function () {
      api.rerender('0cfb2758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/TabPanels.vue"
export default component.exports